export interface IJwtPeticion{
    usuario: string;
    contrasena: string;
    //recuerdame: boolean;
}

export class JwtPeticion implements IJwtPeticion{
    constructor(
        public usuario: string,
        public contrasena: string,
        //public recuerdame: boolean
    ){}
}
